<template>
  <div class="home-page">
    <SearchBarVue />
    <AdBannerCarousel target-group="clients" :placement-id="2" />
    <section class="statics">
      <div class="container">
        <div class="statics__grid">
          <div class="statics__item">
            <b>4000+</b>
            <span>Specjalistów</span>
          </div>
          <div class="statics__item">
            <b>{{ servicesCount || 98 }}</b>
            <span>Dostępnych usług</span>
          </div>
          <div class="statics__item">
            <b>5000+</b>
            <span>Zadowolonych pupili</span>
          </div>
        </div>
      </div>
    </section>

    <section class="highlighted-services section">
      <div class="container">
        <div class="section__head">
          <h2>Wybrane usługi</h2>
          <ButtonVue @click="() => $router.push('/browser')" color="#10b981" bgColor="#fff" text="Zobacz wszystkie" />
        </div>

        <ServiceModal />
        <div class="highlighted-services__services-grid" v-if="randServices.length > 0 && categories.length > 0">
          <ServiceCardVue
            v-for="item in randServices"
            :key="item.id"
            :is-advance="Boolean(item.advanceAmount)"
            :price="item.price"
            :img="item.photo_url"
            :name="item.name"
            :state="states.filter(state => state.value === item.state_id)[0]?.name"
            :ishighlighted="item.active"
            :category="categories.filter(category => category.id === item.user.category_id)[0]?.name"
            :should-show-action-button="true"
            @openServiceModal="() => $router.push({ path: '/', query: { serviceID: item.id } })"
          />
        </div>
        <div v-else class="highlighted-services__services-grid">
          <h3>Brak usług</h3>
        </div>
      </div>
    </section>

    <section class="recommended-trainings section">
      <div class="container">
        <TrainingsVue />
      </div>
    </section>

    <section class="recent-announcements section">
      <div class="container">
        <div class="section__head">
          <h2>Ostatnie ogłoszenia</h2>
          <ButtonVue @click="() => $router.push('/announcements')" color="#10b981" bgColor="#fff" text="Wszystkie ogłoszenia" />
        </div>

        <div class="recent-announcements__announcements-grid" v-if="announcements.length > 0">
          <AnnouncementCardVue
            v-for="announcement in announcements.filter(item => Boolean(item.active) === true)"
            :key="announcement.id"
            :show-active="false"
            :contact="announcement.contact"
            :target="announcement.target"
            :category="announcement.category"
            :img="announcement.photo_url"
            :longContent="announcement.description"
            :id="announcement.id"
            :title="announcement.title"
            :content="announcement.short_description"
            :photo="announcement.photo"
          />
        </div>
        <div v-else class="empty-state">
          <div class="empty-state__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="img" focusable="false">
              <path d="M10 4h8a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h2zm0 2H8a2 2 0 0 0-2 2v8a2 2 0 1 0 4 0V6zm3 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2zm0 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2z"/>
            </svg>
          </div>
          <h3>Brak ogłoszeń</h3>
        </div>
      </div>
    </section>

    <section class="recent-blog-posts section">
      <div class="container">
        <div class="section__head">
          <h2>Ostatnie wpisy bloga</h2>
          <ButtonVue @click="() => $router.push('/blog')" color="#10b981" bgColor="#fff" text="Wszystkie wpisy blogowe" />
        </div>
        <div class="recent-blog-posts__posts-grid" v-if="blogPosts.length > 0">
          <BlogPostCardVue
            v-for="(post, index) in blogPosts"
            :key="index"
            :id="post.id"
            :title="post.title"
            :target="post.target"
            :author="post.author"
            :photo="post.photo_url"
            :created_at="post.created_at"
          />
        </div>
        <div v-else class="empty-state">
          <div class="empty-state__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="img" focusable="false">
              <path d="M10 4h8a2 2 0 0 1 2 2v11a3 3 0 0 1-3 3H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h2zm0 2H8a2 2 0 0 0-2 2v8a2 2 0 1 0 4 0V6zm3 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2zm0 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2z"/>
            </svg>
          </div>
          <h3>Brak postów blogowych</h3>
        </div>
      </div>
    </section>

    <section class="partners section">
      <div class="container">
        <h2>Nasi partnerzy</h2>
        <PartnersVue />
      </div>
    </section>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import SearchBarVue from '@/components/HomeComponents/home/SearchBarVue.vue';
import TrainingsVue from '@/components/HomeComponents/home/Trainings.vue';
import ServiceCardVue from '@/components/SpecialComponents/ServiceCard.vue';
import AnnouncementCardVue from '@/components/SpecialComponents/AnnouncementCard.vue';
import PartnersVue from '@/components/HomeComponents/home/Partners.vue';
import BlogPostCardVue from '@/components/SpecialComponents/BlogPostCard.vue';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import ButtonVue from '@/components/Button.vue';
import { useCancelableRequests } from "@/services/request";
import AdBannerCarousel from "@/components/AdBanner.vue";

export default {
  name: 'HomePage',
  data() {
    return {
      blogPosts: [],
      usersCount: 0,
      servicesCount: 0,
      randServices: [],
      states: [],
      announcements: [],
      categories: [],
      api: null,
      entryTarget: localStorage.getItem('m2vetEntryMode') || 'do wszystkich'
    };
  },
  setup() {
    useMeta({
      title: 'Strona główna',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    });
  },
  components: {
    AdBannerCarousel,
    SearchBarVue,
    TrainingsVue,
    ServiceCardVue,
    AnnouncementCardVue,
    PartnersVue,
    BlogPostCardVue,
    ServiceModal,
    ButtonVue
  },
  created() {
    this.api = useCancelableRequests();
    this.getBlogPosts();
    this.getCounts();
    this.getRandomServices();
    this.getStates();
    this.getAnnouncements();
    this.getCategories();
  },
  beforeUnmount() {
    this.api.cancelAll();
  },
  methods: {
    getBlogPosts() {
      this.api.request('blogPosts', { url: `/GetLatestBlogPosts/${this.entryTarget}`, method: 'get' }).then(res => {
        this.blogPosts = res?.data?.filter(item => item.target === this.entryTarget);
      });
    },
    getCounts() {
      const params = { page: 1, limit: 1 };
      this.api.request('users', { url: '/Users', method: 'post', data: params }).then(res => this.usersCount = res?.data?.count).catch(() => {});
      this.api.request('services', { url: '/Services', method: 'post', data: params }).then(res => this.servicesCount = res?.data?.count).catch(() => {});
    },
    getRandomServices() {
      this.api.request('services', {
        url: '/GetRandomServices',
        method: 'get'
      }).then(res => {
        this.randServices = res.data;
      }).catch(() => {
        console.log('No services found.');
      })
    },
    getStates() {
      this.api.request('states', { url: '/State', method: 'get' }).then(res => {
        res?.data?.forEach((item) => this.states.push({ name: item.name, value: `${item.id}` }));
      });
    },
    getAnnouncements() {
      this.api.request('announcements', { url: `/GetLatestAnnouncements/${this.entryTarget}`, method: 'get' }).then(res => {
        this.announcements = res?.data?.filter(item => item.target === this.entryTarget);
      });
    },
    getCategories() {
      this.api.request('categories', { url: '/Categories', method: 'get' }).then(res => {
        res?.data?.forEach((item) => this.categories.push({ name: item.name, id: `${item.id}` }));
      });
    }
  }
};
</script>

<style lang="scss">
.home-page {
  background: #f9fafb;
  color: #1f2937;
}
.container {
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}
.section {
  padding: 56px 0;
}
.section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}
.section__head h2 {
  margin: 0;
}
.statics {
  background: #10b981;
  color: #fff;
  padding: 48px 0;
  margin-top: 32px;
}
.statics__grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.statics__item {
  text-align: center;
  border-right: 1px solid rgba(255, 255, 255, .25);
}
.statics__item:last-child {
  border-right: none;
}
.statics__item b {
  display: block;
  font-size: 4rem;
}
.statics__item span {
  text-transform: uppercase;
  letter-spacing: .07em;
}
.highlighted-services__services-grid,
.recent-blog-posts__posts-grid,
.recent-announcements__announcements-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.recommended-trainings {
  background: #f3f4f6;
}
.partners h2,
.recent-blog-posts h2 {
  text-align: left;
}

.empty-state {
  margin: 16px 0 8px;
  min-height: 320px;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  color: #6b7280;
  padding: 24px;
}

.empty-state__icon {
  width: 74px;
  height: 74px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #10b981;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.12);
}

.empty-state__icon svg {
  width: 38px;
  height: 38px;
  fill: currentColor;
}

.empty-state h3 {
  margin: 4px 0 0;
  color: #374151;
}

.empty-state p {
  margin: 0;
  max-width: 420px;
  font-size: 1.25rem;
}

@media (max-width: 1024px) {
  .highlighted-services__services-grid,
  .recent-blog-posts__posts-grid,
  .recent-announcements__announcements-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .statics__grid {
    grid-template-columns: 1fr;
  }
  .statics__item {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, .25);
    padding-bottom: 12px;
  }
  .statics__item:last-child {
    border-bottom: none;
  }
}

@media (max-width: 720px) {
  .highlighted-services__services-grid,
  .recent-blog-posts__posts-grid,
  .recent-announcements__announcements-grid {
    grid-template-columns: 1fr;
  }
  .section__head {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>